import React, { Component } from 'react';

/** v3 imports */
import { PortraitModalComponent } from 'styled_components/Common/PortraitModalComponent';
import { UserApi } from 'services/user';
import { RESOLUTIONS } from 'services/config';
import { ModalHeader } from 'styled_components/Common/ModalHeader';
import { ResetPassword } from 'styled_components/Common/ResetPassword';
import { ModalFooter } from 'styled_components/Common/ModalFooter';

const CDN_URL = process.env.REACT_APP_CDN_URL;
const ForgotPasswordImage = `${CDN_URL}common/set-password-modal-icon.svg`;

class ForgotPassword extends Component {
	constructor(props) {
		super(props);

		this.state = {
			email: '',
			success: false,
			error: null,
		};
	}

	toggleOpen = () => {
		const { toggleOpen } = this.props;
		toggleOpen();
		setTimeout(
			function () {
				this.setState({ success: false, email: '', label: '', error: null });
			}.bind(this),
			2000,
		);
	};

	onChange = () => {
		const value = event.target.value;

		this.setState({ email: value, label: 'EMAIL' });
	};

	onClick = () => {
		const { email } = this.state;
		UserApi.resetUserPassword(email)
			.then(response => {
				const validResponse = response.status === 200 && response.data && !response.data.error;
				if (validResponse) {
					this.setState({ success: true });
				} else {
					this.setState({ error: 'Error resetting user password', success: false });
				}
			})
			.catch(error => this.setState({ error }));
	};

	getSize = breakpoint => {
		let size = 'large';
		if (breakpoint === RESOLUTIONS.MED) {
			size = 'medium';
		} else if (breakpoint === RESOLUTIONS.HIGH) {
			size = 'medium';
		}

		return size;
	};

	render() {
		const { success, error, email } = this.state;
		const { isOpen, breakpoint } = this.props;
		return (
			<div className='forgot-password-wrapper'>
				<PortraitModalComponent
					closeModal={this.toggleOpen}
					show={isOpen}
					header={<ModalHeader image={ForgotPasswordImage} text={''} className='forgot-password' />}
					title='Forgot your password?'
					subTitle={`Recieve instructions on how to reset your password.`}
					size={this.getSize(breakpoint)}
					breakpoint={breakpoint}
				>
					<ResetPassword onChange={this.onChange} success={success} error={error} email={email} />
					<div className='reset-button'>
						<ModalFooter
							cypressId='footer'
							id='forgot-password'
							buttonText1='RESET PASSWORD'
							buttonText2=''
							buttonActive1={true}
							module='support'
							buttonFunction1={!success && this.onClick}
							size={this.getSize(breakpoint)}
						/>
					</div>
				</PortraitModalComponent>
			</div>
		);
	}
}
export default ForgotPassword;
